import Card from '@mui/material/Card';
import InfoIcon from '@mui/icons-material/Info';
import { useTheme } from '@mui/material/styles';

interface Props {
  amountOfPoint: any;
}

function ConfirmCard({ amountOfPoint }: Props) {
  const theme = useTheme();

  return (
    <div className="w-full flex justify-center mt-4">
      <Card
        className="p-4 shadow-lg w-80"
        sx={{
          borderRadius: "10px",
          color: "#1E88E5",
        }}
      >
        <div className="flex justify-center items-center">
          <InfoIcon
            className="mr-2"
            sx={{ color: process.env.REACT_APP_PRIMARY_COLOR }}
          />
          <span style={{ color: process.env.REACT_APP_PRIMARY_COLOR }}>
            You have {amountOfPoint} points
          </span>
        </div>
      </Card>
    </div>
  );
}

export default ConfirmCard;
